import { app } from '../app';
import { SpAlert } from '../components/sp-alert/sp-alert.model';

app.service('Alert', Alert);

/** @ngInject */
function Alert($rootScope) {
    return (...args) => $rootScope.globalTopLevelMessage = new SpAlert(...args);
}



// WEBPACK FOOTER //
// ./src/portal/services/alert.service.js